var _g, _g2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 208 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5390_26616)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.136 65.3589C160.136 89.3824 141.314 108.857 118.097 108.857C94.8799 108.857 76.0586 89.3824 76.0586 65.3589C76.0586 41.3354 94.8799 21.8605 118.097 21.8605C141.314 21.8605 160.136 41.3354 160.136 65.3589Z",
    fill: "url(#paint1_linear_5390_26616)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.287,
    cy: 95.8079,
    rx: 24.1264,
    ry: 25.1534,
    fill: "#C9C3D3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.093 78.7708C124.106 78.7614 124.119 78.752 124.132 78.7424C131.131 73.4926 141.665 65.1768 150.998 56.8816C155.662 52.7361 160.065 48.5618 163.587 44.7551C167.031 41.0327 169.896 37.3874 171.172 34.323C171.788 32.8425 172.183 31.3048 172.049 29.8135C171.901 28.1564 171.106 26.7274 169.749 25.7994C168.542 24.9746 167.144 24.7175 165.954 24.6601C164.721 24.6008 163.394 24.742 162.079 24.9839C156.903 25.9359 150.206 28.7859 145.705 31.0365C144.241 31.7683 143.658 33.58 144.402 35.0831C145.145 36.5861 146.935 37.2112 148.399 36.4794C152.782 34.2877 158.885 31.7415 163.232 30.9419C164.298 30.7459 165.147 30.677 165.774 30.7072C165.888 30.7127 165.987 30.7211 166.072 30.731C166.015 30.9928 165.904 31.3693 165.691 31.8807C164.857 33.8846 162.646 36.8683 159.226 40.5645C155.885 44.1764 151.637 48.2104 147.045 52.2917C137.866 60.4503 127.465 68.6626 120.553 73.8467C120.309 74.0295 120.102 74.2436 119.932 74.4799C113.643 78.9895 103.719 85.7039 94.2489 91.2922C89.478 94.1074 84.8753 96.6053 80.9394 98.3898C76.8566 100.241 73.9473 101.106 72.3753 101.106C72.1422 101.106 71.9605 101.093 71.8219 101.076C71.8489 100.912 71.8979 100.695 71.9848 100.416C72.188 99.7653 72.5421 98.9612 73.0551 98.022C75.1465 94.1932 79.1548 89.4055 82.2971 86.1212C83.4425 84.924 83.4006 83.025 82.2034 81.8796C81.0063 80.7342 79.1072 80.7761 77.9618 81.9733C74.707 85.3752 70.2633 90.6168 67.7894 95.1457C67.1612 96.2959 66.6169 97.4768 66.2574 98.6281C65.9078 99.7479 65.6661 101.049 65.8598 102.353C66.071 103.774 66.7991 105.123 68.1708 106.025C69.425 106.85 70.9225 107.106 72.3753 107.106C75.3783 107.106 79.3525 105.697 83.4171 103.854C87.6287 101.945 92.4376 99.3277 97.2981 96.4597C107.027 90.719 117.174 83.8463 123.558 79.2631C123.76 79.1179 123.939 78.9521 124.093 78.7708Z",
    fill: "#385980",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5390_26616",
    x: 0,
    y: 0,
    width: 208,
    height: 196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5390_26616"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5390_26616",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5390_26616",
    x1: 104,
    y1: 0,
    x2: 104,
    y2: 188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#509FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A56FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5390_26616",
    x1: 118.097,
    y1: 21.8605,
    x2: 118.097,
    y2: 108.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA6FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711CF1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.cae1cce840d384b854ade53e27bd06e9.svg";
export { ForwardRef as ReactComponent };